import React from "react";
import Standard from "./Standard";
import Pro from "./Pro";
import StandardPlus from "./StandardPlus";

const Price = ({ activeTab, rateData }) => {
  return (
    <div>
      <Standard />
      <StandardPlus activeTab={activeTab} rateData={rateData.tariffs} />
      <Pro activeTab={activeTab} rateData={rateData.tariffs} />
    </div>
  );
};

export default Price;
